<script lang="ts">
    export let data: Record<string, any>
</script>

<div class="block-preview">
    <input type="date" class="preview-input" disabled />
</div>

<style>
    .block-preview {
        width: 100%;
    }
    .preview-input {
        border: 1px solid #ced4da;
        border-radius: 6px;
        padding: 6px 10px;
        font-size: 0.9rem;
        background: #fff !important;
        color: #868e96;
    }
</style>
